export default __webpack_public_path__ + "static/media/arrow-right.f2a8f21ce04ab407757eba554e160ead.svg";